import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/PaymentSuccess.css';

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);
  const [showConfetti, setShowConfetti] = useState(true);

  const paymentId = searchParams.get('payment_id');
  const clientName = searchParams.get('client_name') || 'Client';

  useEffect(() => {
    // Countdown pour redirection automatique
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/');
          return 0;
        }
        return prev - 1;
      });
    }, 7000);

    // Arrêter les confettis après 3 secondes
    const confettiTimer = setTimeout(() => {
      setShowConfetti(false);
    }, 3000);

    return () => {
      clearInterval(timer);
      clearTimeout(confettiTimer);
    };
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleViewOrder = () => {
    if (paymentId) {
      navigate(`/order/${paymentId}`);
    }
  };

  return (
    <div className="payment-success-page">
      {showConfetti && (
        <div className="confetti-container">
          {[...Array(50)].map((_, i) => (
            <div key={i} className="confetti" style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              backgroundColor: ['#667eea', '#764ba2', '#f093fb', '#4facfe'][Math.floor(Math.random() * 4)]
            }}></div>
          ))}
        </div>
      )}

      <div className="success-container">
        <div className="success-icon">
          <svg width="100" height="100" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" fill="#10b981" />
            <path d="M30 50 L45 65 L70 35" stroke="white" strokeWidth="6" fill="none" strokeLinecap="round" strokeLinejoin="round">
              <animate attributeName="stroke-dasharray" from="0, 100" to="100, 0" dur="0.5s" fill="freeze" />
            </path>
          </svg>
        </div>

        <h1 className="success-title">
          🎉 {t('paymentSuccess.title', 'Paiement réussi !')}
        </h1>

        <p className="success-message">
          {t('paymentSuccess.message', 'Merci {{name}} ! Votre paiement a été confirmé avec succès.', { name: clientName })}
        </p>

        <div className="success-details">
          <div className="detail-item">
            <span className="detail-icon">✉️</span>
            <div>
              <h3>{t('paymentSuccess.emailSent', 'Email de confirmation envoyé')}</h3>
              <p>{t('paymentSuccess.emailDesc', 'Un email de confirmation avec tous les détails a été envoyé à votre adresse.')}</p>
            </div>
          </div>

          <div className="detail-item">
            <span className="detail-icon">📊</span>
            <div>
              <h3>{t('paymentSuccess.tracking', 'Suivi de projet')}</h3>
              <p>{t('paymentSuccess.trackingDesc', 'Vous pouvez suivre l\'avancement de votre projet en temps réel.')}</p>
            </div>
          </div>

          <div className="detail-item">
            <span className="detail-icon">🚀</span>
            <div>
              <h3>{t('paymentSuccess.nextSteps', 'Prochaines étapes')}</h3>
              <p>{t('paymentSuccess.nextStepsDesc', 'Je vais commencer à travailler sur votre projet. Vous recevrez des mises à jour régulières.')}</p>
            </div>
          </div>
        </div>

        <div className="success-actions">
          {/* {paymentId && (
            <button onClick={handleViewOrder} className="btn-primary">
              📊 {t('paymentSuccess.viewOrder', 'Voir mon projet')}
            </button>
          )} */}
          <button onClick={handleGoHome} className="btn-secondary">
            🏠 {t('paymentSuccess.goHome', 'Retour à l\'accueil')}
          </button>
        </div>

        <div className="auto-redirect">
          {t('paymentSuccess.autoRedirect', 'Redirection automatique dans {{seconds}} secondes...', { seconds: countdown })}
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;